import { Icon } from "./Icon.tsx";

/** A map pin with a small crosshair — the two-halves-of-one-correspondence metaphor this tool is about. */
export function GeoreferenceIcon() {
  return (
    <Icon>
      <path d="M12 21s7-7.5 7-12a7 7 0 1 0-14 0c0 4.5 7 12 7 12Z" />
      <circle cx="12" cy="9" r="1.6" fill="currentColor" stroke="none" />
      <path d="M12 6v1.5M12 10.5V12M9 9h1.5M13.5 9H15" />
    </Icon>
  );
}
